import { render, staticRenderFns } from "./LIAContacts.vue?vue&type=template&id=5d5981bf&scoped=true"
import script from "./LIAContacts.vue?vue&type=script&lang=js"
export * from "./LIAContacts.vue?vue&type=script&lang=js"
import style0 from "./LIAContacts.vue?vue&type=style&index=0&id=5d5981bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5981bf",
  null
  
)

export default component.exports